exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".theme-brand .vdatetime-calendar__month__day--selected:hover>span>span,.theme-brand .vdatetime-calendar__month__day--selected>span>span,.theme-brand .vdatetime-popup__header{background:var(--brand-color)}.theme-brand .vdatetime-popup__actions__button,.theme-brand .vdatetime-time-picker__item--selected,.theme-brand .vdatetime-year-picker__item--selected{color:var(--brand-color)}", ""]);

// exports
